import User1 from "assets/images/users/1.jpg";
import User2 from "assets/images/users/01.jpg";
import Avatar from "components/Avatar/Avatar";
import Chip from "components/Chip/Chip";
import styles from "./Activity.module.scss";

const ActivityItem = ({ activityLog }: any) => {
  return (
    <div className={styles.listItem}>
      <Avatar
        alt={activityLog.fullName}
        src={activityLog.picture}
        status={activityLog.status}
        size="50"
      />
      <div className={styles.itemText}>
        <div className={styles.userInfo}>
          <h4>{activityLog.fullName}</h4>
          <span>{activityLog.logTime}</span>
        </div>
        <p className={styles.messageSummary}>{activityLog.activity}</p>
      </div>
      {activityLog.isNew && <Chip type="dot" variant="success"><span></span></Chip>}
    </div>
  );
};

export default function Activity() {
  const data = [
    {
      id: '1',
      picture: User1,
      fullName: 'Phoenix Baker',
      activity: 'Finished assessment on Optimise Company Supply Chain',
      logTime: '3:10pm 20 Jan 2022',
      status: 'Available',
      isNew: true
    },
    {
      id: '2',
      picture: User2,
      fullName: 'You',
      activity: 'Added Find a new vendor in unaffected region to Enhance our supply chain project',
      logTime: '3:10pm 20 Jan 2022',
      status: 'Available',
      isNew: true
    },
    {
      id: '3',
      picture: User2,
      fullName: 'You',
      activity: 'EYRN send an inquiry to Darrin Karras about this risk and have him get back to me by Friday.',
      logTime: '5 mins ago',
      status: 'Available'
    }
  ];

  return (
    <div className="pv-3">
      {data.map((item, index) => (
        <div key={`activity-${index}`}>
          <ActivityItem activityLog={item} />
        </div>
      ))}
    </div>
  );
}
